import { z } from 'zod';
import { ALL_PERMISSIONS, ROLE_KINDS } from '@/constants/permissions';

/**
 * Mirrors the backend's `roles.validation.ts`. The server is the authority; this
 * catches a blank name or an empty permission list before the round trip.
 */
export const roleSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Give the role a name')
    .max(60, 'That name is too long')
    .regex(/^[\p{L}\p{N} ()&/-]+$/u, 'Letters, numbers, spaces and ( ) & / - only'),
  description: z
    .string()
    .trim()
    .max(160, 'Keep it under 160 characters')
    .optional()
    .or(z.literal(''))
    // Null rather than undefined, which JSON drops: an edit that empties the
    // description must still send it, or the server keeps the old one.
    .transform((value) => value || null),
  kind: z.enum(ROLE_KINDS, { errorMap: () => ({ message: 'Choose who this role is for' }) }),
  permissions: z
    .array(z.enum(ALL_PERMISSIONS as [(typeof ALL_PERMISSIONS)[number], ...typeof ALL_PERMISSIONS]))
    .min(1, 'Choose at least one permission'),
});

export type RoleFormValues = z.input<typeof roleSchema>;
export type RolePayload = z.output<typeof roleSchema>;
